import React from "react";

const CommentSkeleton: React.FC<{ className?: string; fluid?: boolean }> = ({ className = "", fluid = false }) => {
  return (
    <div className={`flex h-[250px] ${fluid ? "w-full min-w-0" : "w-[343px] min-w-[313px] shrink-0 tablet:min-w-[343px]"} animate-pulse flex-col rounded-2xl border border-gray-200 bg-white p-4 tablet:h-[252px] ${className}`}>
      <div className="flex items-center gap-3 pb-3">
        <div className="h-14 w-14 rounded-xl bg-gray-200" />
        <div className="space-y-2">
          <div className="h-3 w-28 rounded bg-gray-200" />
          <div className="h-2.5 w-20 rounded bg-gray-200" />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 border-y border-gray-100 py-3">
        <div className="h-3 w-full rounded bg-gray-200" />
        <div className="h-3 w-full rounded bg-gray-200" />
        <div className="h-3 w-5/6 rounded bg-gray-200" />
      </div>

      <div className="flex items-center justify-between pt-3">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-full bg-gray-200" />
          <div className="h-3 w-24 rounded bg-gray-200" />
        </div>
        <div className="h-3 w-16 rounded bg-gray-200" />
      </div>
    </div>
  );
};

export default CommentSkeleton;
